export const ENVIRONMENT: string = process.env.ENV || 'dev'

interface ConfigValues {
  apiUrl: string
}

interface Config {
  [config: string]: ConfigValues
}

export const CONFIG: Config = {
  local: {
    apiUrl: 'http://localhost:3001/api/v1',
  },
  dev: {
    apiUrl: 'https://dev-api.nhrapp.com/api/v1',
  },
  prod: {
    apiUrl: 'https://api.nhrapp.com/api/v1',
  },
}

// Runtime hostname → API URL mapping. Mirrors nhrapp-react/src/config.ts so a single
// bundle can be served from multiple SPA hosts and route to the matching same-site
// API. See that file for the full rationale (Safari ITP / Brave Shields blocking
// cross-site cookies in default settings).
//
// Order matters — first match wins, so put more-specific suffixes before more-general
// ones (e.g. `dev-admin.nhrapp.com` before `nhrapp.com`).
const HOSTNAME_TO_API_URL: Array<[string, string]> = [
  // ── DEV ──
  ['dev-admin.nhrapp.com',  'https://dev-api.nhrapp.com/api/v1'],

  // ── PROD ──
  // admin.pieceworkpro.com (the only prod admin SPA host) → same-site
  // api.pieceworkpro.com, which CNAMEs to the existing api.nhrapp.com backend.
  ['pieceworkpro.com',      'https://api.pieceworkpro.com/api/v1'],
  ['nhrapp.com',            'https://api.nhrapp.com/api/v1'],

  // ── LEGACY ──
  ['ondigitalocean.app',    'https://dev-api.nhrapp.com/api/v1'],
  ['rapidinnovation.tech',  'https://dev-api.nhrapp.com/api/v1'],
]

const detectApiUrl = (envDefault: string): string => {
  if (typeof window === 'undefined') return envDefault
  const host = window.location.hostname
  for (const [suffix, apiUrl] of HOSTNAME_TO_API_URL) {
    if (host === suffix || host.endsWith(`.${suffix}`)) return apiUrl
  }
  return envDefault
}

export const getConfig = (): ConfigValues => {
  const base = CONFIG[ENVIRONMENT]
  if (ENVIRONMENT === 'local') return base
  return { ...base, apiUrl: detectApiUrl(base.apiUrl) }
}
